import BBookIcon from './BBookIcon'
import BBookInfo from './BBookInfo'
import { money, signedMoney } from '../report/pnlCharts'

const FORMATS = {
  money: (value) => money(value),
  signed: (value) => signedMoney(value),
  percent: (value) => `${String(value).replace('.', ',')} %`,
  count: (value) => new Intl.NumberFormat('fr-FR').format(value),
}

// A read-only figure: no hover lift or link affordance, tabular digits, and a signed value says its direction with an arrow, not colour alone.
const BBookKpi = ({ label, value, format = 'money', hint, info }) => {
  const missing = value === null || value === undefined || Number.isNaN(value)
  const tone = format === 'signed' && !missing && Number(value) !== 0 ? (value > 0 ? 'gain' : 'loss') : ''

  return (
    <div className='b_book_kpi'>
      {info ? <BBookInfo label={label} text={info} /> : null}
      <p className='b_book_kpi_label'>{label}</p>
      <p className={`b_book_kpi_value ${tone ? `b_book_kpi_${tone}` : ''}`}>
        {tone && <BBookIcon name={tone === 'gain' ? 'up' : 'down'} size={20} />}
        {missing ? '—' : FORMATS[format](value)}
      </p>
      {hint ? <p className='b_book_kpi_hint'>{hint}</p> : null}
    </div>
  )
}

export default BBookKpi
